import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { noop } from 'rxjs';
import { Store } from '@ngrx/store';
import { BaseButtonSize } from '../../../../../shared/components/button/base-button.component';
import { BaseFilterInterface } from '../../../../../shared/interfaces/base-filter.interface';
import { GroupUpdateRequest, PermissionItemResponse } from '../../../../../../api';
import { BaseModalService } from '../../../../../shared/services/base-modal.service';
import { BaseCoreState, baseUserActions } from '../../../../../_store';
import {
  CUSTOMER_PERMISSIONS_PRIORITIES,
  PSP_PERMISSIONS_PRIORITIES,
} from '../../../_constans/permissions-priorities.const';
import { BaseRolesService } from '../../../../../core/services/base-roles.service';

@Component({
  selector: 'base-permission-groups',
  templateUrl: './base-permission-groups.component.html',
})
export class BasePermissionGroupsComponent implements OnInit {
  @ViewChild('addPermissionGroupTemplate', { static: true }) addPermissionGroupTemplate: ElementRef;
  @ViewChild('editPermissionGroupTemplate', { static: true }) editPermissionGroupTemplate: ElementRef;
  @Input() permissions: PermissionItemResponse[] = [];
  @Input() selectedFilter: BaseFilterInterface;
  @Output() selectFilter = new EventEmitter<BaseFilterInterface>();

  isPSP: boolean;
  modalRef: NgbModalRef;
  buttonSizes = BaseButtonSize;
  permissionsWithPriorities: (PermissionItemResponse & { priority: number })[] = [];

  constructor(
    private modalService: BaseModalService,
    private store: Store<BaseCoreState>,
    private rolesService: BaseRolesService
  ) {}

  ngOnInit() {
    this.isPSP = this.rolesService.isPsp();
    this.permissionsWithPriorities = this.permissions
      .map((permission) => {
        const permissionsPriorities = this.isPSP ? PSP_PERMISSIONS_PRIORITIES : CUSTOMER_PERMISSIONS_PRIORITIES;
        return {
          ...permission,
          priority: permissionsPriorities[permission.key] ?? 0,
        };
      })
      .sort((a, b) => a.priority - b.priority);
  }

  onSelectUserGroup(selectedFilter: BaseFilterInterface): void {
    this.selectFilter.emit(selectedFilter);
  }

  openAddGroupModal(): void {
    this.modalRef = this.modalService.open(
      {
        headText: 'user.addPermissionGroup',
        bodyTemplate: this.addPermissionGroupTemplate,
        okButtonDisplayed: false,
        cancelButtonDisplayed: false,
        hideFooter: true,
      },
      {
        size: 'lg',
      }
    );

    this.modalRef.result.then(noop, noop);
  }

  openEditGroupModal(): void {
    this.modalRef = this.modalService.open(
      {
        headText: 'user.editPermissionGroup',
        bodyTemplate: this.editPermissionGroupTemplate,
        okButtonDisplayed: false,
        hideFooter: true,
      },
      {
        size: 'lg',
      }
    );
    this.modalRef.result.then(noop, noop);
  }

  updatePermissionGroup(payload: { groupId: number; body: GroupUpdateRequest }): void {
    this.store.dispatch(baseUserActions.updateGroupCrud({ payload }));
  }
}
